// extracted by mini-css-extract-plugin
export var aiStarIcon = "_j5-2";
export var container = "_j5-4";
export var dismissButton = "_j5-3";
export var hasPaddingBottom = "_j5-6";
export var last = "_j5-e";
export var scrollbarThumb = "_j5-c";
export var scrollbarTrack = "_j5-b";
export var selected = "_j5-9";
export var spin = "_j5-1";
export var spinning = "_j5-0";
export var suggestionItem = "_j5-d";
export var suggestionsPanel = "_j5-5";
export var tonePill = "_j5-8";
export var tonesContainer = "_j5-7";
export var unselected = "_j5-a";